import { network } from '@root/utils'
import { MutationFunction } from './root'
import { handleReturn } from './root'

export interface ISendIfInsuranceProps {
  slug: string
}

export const sendIfInsuranceForm: MutationFunction<ISendIfInsuranceProps, undefined> = async ({
  slug
}) => {
  const url = `/v1/business/${slug}/partner/if/form/send/`
  const { data, status } = await network.httpClient.request({
    url,
    method: 'POST',
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}
